import React, { Dispatch } from 'react';

export const RESET_STATE = 'RESET_STATE';
export const SET_SEARCH_ORDER_ITEM = 'SET_SEARCH_ORDER_ITEM';
export const SET_SEARCH_ORDER_ITEM_LOADING = 'SET_SEARCH_ORDER_ITEM_LOADING';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_SEARCH_OBJ = 'SET_SEARCH_OBJ';
export const SET_IS_FROM_ITEMDETAIL = 'SET_IS_FROM_ITEMDETAIL';
export const SET_APPLIED_STATS_FILTER = 'SET_APPLIED_STATS_FILTER';


export const INITIAL_SET_ORDER_ITEMS = {
  searchorderItems: [],
  searchorderItemsLoading: false,
  searchText: null,
  searchObj: null,
  isFromDetail: false,
  appliedStatsFilter: [],

};


export const SearchOrderItemReducer = (state, action) => {
  switch (action.type) {
    case SET_SEARCH_ORDER_ITEM:
      return { ...state, searchorderItems: action.searchorderItems };
    case SET_IS_FROM_ITEMDETAIL:
      return { ...state, isFromDetail: action.isFromDetail };
    case SET_SEARCH_ORDER_ITEM_LOADING:
      return { ...state, searchorderItemsLoading: action.searchorderItemsLoading };
    case SET_SEARCH_TEXT:
      return { ...state, searchText: action.searchText };
    case SET_SEARCH_OBJ:
      return { ...state, searchObj: { ...action.searchObj } };
    case SET_APPLIED_STATS_FILTER:
      return { ...state, appliedStatsFilter: action.appliedStatsFilter };
    case RESET_STATE:
      return INITIAL_SET_ORDER_ITEMS;
    default:
      return INITIAL_SET_ORDER_ITEMS;
  }
};

export const SearchOrderItemContext = React.createContext(INITIAL_SET_ORDER_ITEMS);
